define(["jquery", "wcs.context"],function($, ctx) {
	var isKiosk = ctx.getCookie("cn3"),
		kioskIdCookie = ctx.getCookie("kiosk_id");

	if(isKiosk === '1'){
		$('.clear-session-template-js').appendTo('#body-container');
		$('.clear-session-js').removeClass("hide");

		$('.clear-session-js a').on('click', function(e){
			e.preventDefault();
			ctx.removeCookies(".*");		//Removes all cookies

			if (typeof kioskIdCookie !== 'undefined') {
				location.href = WCS_CONFIG.get('global::kioskClearSessionReturnURL')+"&kioskId="+kioskIdCookie;
			} else {
				if($('body#checkout').size() > 0)	//Refresh of checkout pages after removing cookies causes security errors
					location.href = location.origin;
				else
					location.reload();
			}
		});
	}
});